import type { Video } from "@/types/video";

export const videos: Video[] = [
  {
    id: "v-movie-01",
    title: "荒原信使",
    type: "movie",
    categoryId: "movie-action",
    genres: ["动作", "冒险"],
    region: "中国大陆",
    year: 2025,
    duration: "126分钟",
    director: "陈牧",
    cast: ["段宏", "林夏", "周予"],
    summary:
      "末世后的荒原上，一名独行信使护送最后一封手写信穿越沙暴与掠夺者营地。当信件背后的秘密被揭开，他必须决定是完成承诺，还是转身逃离。",
    rating: 8.6,
    views: 12840000,
    updatedAt: "2026-10-14",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20wide%20shot%20of%20a%20lone%20courier%20walking%20through%20a%20vast%20dusty%20wasteland%20at%20dusk%2C%20huge%20orange%20dust%20storm%20behind%20him%2C%20silhouetted%20figure%20with%20long%20coat%2C%20dramatic%20backlight%2C%20anamorphic%20film%20still%2C%20high%20detail%2C%20no%20text&width=1280&height=720&seq=btb-movie-action-01&orientation=landscape",
    featured: true,
  },
  {
    id: "v-movie-02",
    title: "逆流之城",
    type: "movie",
    categoryId: "movie-drama",
    genres: ["剧情", "社会"],
    region: "中国香港",
    year: 2024,
    duration: "112分钟",
    director: "许岸",
    cast: ["何文", "苏芷"],
    summary:
      "一位在旧城区经营修表铺的中年人，因一场拆迁风波重新面对二十年前的选择。城市的霓虹照旧亮起，有些人却再也回不到原来的位置。",
    rating: 8.3,
    views: 6120000,
    updatedAt: "2026-10-08",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20night%20street%20of%20a%20dense%20old%20city%20district%20with%20warm%20neon%20signs%20reflected%20on%20wet%20asphalt%2C%20a%20small%20watch%20repair%20shop%20window%20glowing%20softly%2C%20moody%20atmosphere%2C%20film%20still%2C%20no%20text&width=1280&height=720&seq=btb-movie-drama-01&orientation=landscape",
  },
  {
    id: "v-movie-03",
    title: "星际回声",
    type: "movie",
    categoryId: "movie-scifi",
    genres: ["科幻", "冒险"],
    region: "中国大陆",
    year: 2025,
    duration: "134分钟",
    director: "罗维",
    cast: ["江野", "白露"],
    summary:
      "深空监听站接收到一段来自四十年前的信号，内容是尚未发生的对话。两名值守宇航员在孤独的舱室里，开始怀疑自己是否早已被写进这段回声。",
    rating: 8.8,
    views: 15320000,
    updatedAt: "2026-10-16",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20deep%20space%20scene%20with%20a%20lone%20orbital%20listening%20station%20silhouetted%20against%20a%20giant%20amber%20planet%2C%20cold%20blue%20starlight%20and%20warm%20orange%20rim%20light%2C%20volumetric%20dust%2C%20sci-fi%20film%20still%2C%20no%20text&width=1280&height=720&seq=btb-movie-scifi-01&orientation=landscape",
    featured: true,
  },
  {
    id: "v-movie-04",
    title: "第七夜",
    type: "movie",
    categoryId: "movie-thriller",
    genres: ["悬疑", "犯罪"],
    region: "中国大陆",
    year: 2025,
    duration: "108分钟",
    director: "高未",
    cast: ["邵川", "程一"],
    summary:
      "连续七个雨夜，同一通报警电话打进了警局。接线员发现，电话那头的女人每次都描述着明天才会发生的案子。第七夜，她说的受害者是自己。",
    rating: 8.1,
    views: 8940000,
    updatedAt: "2026-10-11",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20rainy%20night%20city%20alley%20lit%20by%20a%20single%20flickering%20streetlamp%2C%20wet%20brick%20walls%2C%20distant%20figure%20under%20an%20umbrella%2C%20deep%20shadows%20and%20teal%20highlights%2C%20suspense%20film%20still%2C%20no%20text&width=1280&height=720&seq=btb-movie-thriller-01&orientation=landscape",
  },
  {
    id: "v-movie-05",
    title: "今天也很忙",
    type: "movie",
    categoryId: "movie-comedy",
    genres: ["喜剧", "家庭"],
    region: "中国大陆",
    year: 2024,
    duration: "98分钟",
    director: "许岸",
    cast: ["张小满", "李大鹏"],
    summary:
      "一个总在加班的产品经理，被迫在一天之内同时搞定年度汇报、丈母娘来访和小区业主群。所有事情都赶在一起，也所有事情都赶巧了。",
    rating: 7.8,
    views: 5210000,
    updatedAt: "2026-09-29",
    cover:
      "https://readdy.ai/api/search-image?query=bright%20cinematic%20comedy%20scene%20of%20a%20messy%20modern%20apartment%20with%20scattered%20paperwork%20and%20a%20half%20packed%20suitcase%2C%20warm%20daylight%20through%20big%20windows%2C%20playful%20energetic%20mood%2C%20film%20still%2C%20no%20text&width=1280&height=720&seq=btb-movie-comedy-01&orientation=landscape",
  },
  {
    id: "v-movie-06",
    title: "夏日信箱",
    type: "movie",
    categoryId: "movie-romance",
    genres: ["爱情", "青春"],
    region: "中国台湾",
    year: 2023,
    duration: "105分钟",
    director: "温澜",
    cast: ["苏芷", "林夏"],
    summary:
      "海边小镇的旧邮局里，两个陌生人通过一个无人认领的信箱开始通信。他们约定不见面，却在夏天结束前同时站在了邮局门口。",
    rating: 8.0,
    views: 4470000,
    updatedAt: "2026-09-21",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20seaside%20town%20in%20golden%20summer%20light%2C%20old%20post%20office%20with%20a%20row%20of%20blue%20mailboxes%2C%20soft%20sea%20breeze%2C%20warm%20sunlight%20and%20gentle%20nostalgic%20tone%2C%20film%20still%2C%20no%20text&width=1280&height=720&seq=btb-movie-romance-01&orientation=landscape",
  },
  {
    id: "v-movie-07",
    title: "暗涌追缉",
    type: "movie",
    categoryId: "movie-action",
    genres: ["动作", "犯罪"],
    region: "中国大陆",
    year: 2026,
    duration: "119分钟",
    director: "陈牧",
    cast: ["段宏", "邵川", "周予"],
    summary:
      "一桩看似普通的走私案，牵出横跨三座城市的暗线网络。老刑警带着刚入职的搭档一路追查，在最后一班渡轮上迎来了无法回避的对峙。",
    rating: 8.4,
    views: 19860000,
    updatedAt: "2026-10-16",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20night%20harbor%20chase%20scene%2C%20two%20figures%20running%20along%20a%20container%20dock%2C%20orange%20crane%20lights%20and%20cold%20blue%20reflections%20on%20water%2C%20motion%20blur%2C%20gritty%20action%20film%20still%2C%20no%20text&width=1280&height=720&seq=btb-movie-action-02&orientation=landscape",
    featured: true,
  },
  {
    id: "v-movie-08",
    title: "山海之外",
    type: "movie",
    categoryId: "movie-scifi",
    genres: ["科幻", "剧情"],
    region: "中国大陆",
    year: 2024,
    duration: "121分钟",
    director: "罗维",
    cast: ["江野", "何文"],
    summary:
      "海平面上升后，人类把城市搬进了山体内部。一位地形测绘师在旧海图上发现了一块不该存在的陆地，也发现父亲留下的坐标一直指向那里。",
    rating: 7.9,
    views: 5630000,
    updatedAt: "2026-10-02",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20surreal%20landscape%20of%20a%20flooded%20future%20city%20with%20towers%20emerging%20from%20calm%20water%2C%20misty%20mountains%20in%20the%20distance%2C%20muted%20teal%20and%20amber%20palette%2C%20epic%20sci-fi%20film%20still%2C%20no%20text&width=1280&height=720&seq=btb-movie-scifi-02&orientation=landscape",
  },
  {
    id: "v-movie-09",
    title: "无声证词",
    type: "movie",
    categoryId: "movie-thriller",
    genres: ["悬疑", "剧情"],
    region: "中国大陆",
    year: 2023,
    duration: "116分钟",
    director: "高未",
    cast: ["程一", "何文"],
    summary:
      "一名手语翻译被请去协助审理一起聋哑证人的案件，却发现证人的每一次比划都与卷宗里的记录相差一字。那一字之差，足以让真凶走出法庭。",
    rating: 8.5,
    views: 7320000,
    updatedAt: "2026-09-18",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20empty%20courtroom%20interior%20with%20shafts%20of%20hard%20daylight%20through%20tall%20windows%2C%20long%20wooden%20bench%20and%20a%20single%20lone%20chair%2C%20high%20contrast%20shadows%2C%20tense%20film%20still%2C%20no%20text&width=1280&height=720&seq=btb-movie-thriller-02&orientation=landscape",
  },
  {
    id: "v-movie-10",
    title: "慢半拍的爱",
    type: "movie",
    categoryId: "movie-romance",
    genres: ["爱情", "喜剧"],
    region: "中国大陆",
    year: 2025,
    duration: "99分钟",
    director: "温澜",
    cast: ["白露", "张小满"],
    summary:
      "一个说话总比别人慢半拍的电台主播，和一个永远赶时间的急诊科护士，在凌晨三点的直播间里，把彼此的日子调成了同一个速度。",
    rating: 7.6,
    views: 3980000,
    updatedAt: "2026-09-30",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20cozy%20late%20night%20radio%20studio%20with%20warm%20lamp%20light%2C%20large%20microphone%20and%20vinyl%20records%2C%20city%20lights%20blurred%20through%20the%20window%2C%20soft%20intimate%20mood%2C%20film%20still%2C%20no%20text&width=1280&height=720&seq=btb-movie-romance-02&orientation=landscape",
  },
  {
    id: "v-movie-11",
    title: "铁轨尽头",
    type: "movie",
    categoryId: "movie-drama",
    genres: ["剧情", "公路"],
    region: "中国大陆",
    year: 2022,
    duration: "124分钟",
    director: "沈青",
    cast: ["段宏", "周予"],
    summary:
      "即将停运的支线铁路上，最后一班列车载着七个各有心事的乘客。列车长决定在终点站之前，为每个人多停一次车。",
    rating: 8.2,
    views: 4860000,
    updatedAt: "2026-08-26",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20long%20shot%20of%20an%20old%20green%20train%20crossing%20a%20rusty%20railway%20bridge%20at%20sunset%2C%20dry%20grassland%20and%20distant%20hills%2C%20warm%20golden%20haze%2C%20nostalgic%20film%20still%2C%20no%20text&width=1280&height=720&seq=btb-movie-drama-02&orientation=landscape",
  },
  {
    id: "v-movie-12",
    title: "霓虹谈判",
    type: "movie",
    categoryId: "movie-action",
    genres: ["动作", "悬疑"],
    region: "中国香港",
    year: 2026,
    duration: "110分钟",
    director: "沈青",
    cast: ["邵川", "苏芷"],
    summary:
      "谈判专家接到一通没有诉求的电话，对方只要求他讲一个故事。当故事讲到结尾，整栋大楼的灯同时熄灭，真正的交易才刚刚开始。",
    rating: 7.7,
    views: 10230000,
    updatedAt: "2026-10-13",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20rooftop%20scene%20above%20a%20neon%20lit%20metropolis%20at%20night%2C%20silhouette%20of%20a%20negotiator%20holding%20a%20phone%2C%20red%20and%20orange%20glow%20from%20signage%2C%20rainy%20air%2C%20stylish%20thriller%20film%20still%2C%20no%20text&width=1280&height=720&seq=btb-movie-action-03&orientation=landscape",
  },
  {
    id: "v-series-01",
    title: "长夜将明",
    type: "series",
    categoryId: "series-urban",
    genres: ["都市", "悬疑"],
    region: "中国大陆",
    year: 2026,
    duration: "全24集",
    director: "顾未",
    cast: ["何文", "林夏", "程一"],
    summary:
      "一名夜班出租车司机连续三年在同一时间接到同一位乘客，直到某天乘客没有出现。他顺着对方留下的地址找过去，撞进了一桩被所有人遗忘的旧案。",
    rating: 8.7,
    views: 22160000,
    updatedAt: "2026-10-16",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20empty%20city%20street%20at%20blue%20hour%20with%20a%20yellow%20taxi%20parked%20under%20tall%20apartment%20blocks%2C%20warm%20window%20lights%2C%20light%20rain%2C%20calm%20lonely%20atmosphere%2C%20series%20still%2C%20no%20text&width=1280&height=720&seq=btb-series-urban-01&orientation=landscape",
    featured: true,
  },
  {
    id: "v-series-02",
    title: "京华旧梦",
    type: "series",
    categoryId: "series-costume",
    genres: ["古装", "剧情"],
    region: "中国大陆",
    year: 2025,
    duration: "全40集",
    director: "陆知",
    cast: ["白露", "江野", "何文"],
    summary:
      "旧朝覆灭前夜，掌管宫廷档案的女官偷偷抄录了一整部实录。多年后，这本册子成为新朝修史的唯一依据，也让她成为所有人争抢的关键。",
    rating: 8.4,
    views: 18630000,
    updatedAt: "2026-10-05",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20ancient%20chinese%20palace%20corridor%20in%20early%20morning%20mist%2C%20red%20lacquered%20pillars%20and%20carved%20eaves%2C%20a%20woman%20in%20traditional%20robes%20holding%20an%20old%20book%2C%20soft%20golden%20light%2C%20historical%20drama%20still%2C%20no%20text&width=1280&height=720&seq=btb-series-costume-01&orientation=landscape",
  },
  {
    id: "v-series-03",
    title: "厨房里的春天",
    type: "series",
    categoryId: "series-family",
    genres: ["家庭", "治愈"],
    region: "中国大陆",
    year: 2024,
    duration: "全28集",
    director: "温澜",
    cast: ["张小满", "李大鹏", "周予"],
    summary:
      "一家开了三十年的小饭馆面临关店，散落在各地的三个孩子陆续回到老屋。灶火重新点起来的那天，很多年没说的话也一起翻了出来。",
    rating: 8.3,
    views: 9650000,
    updatedAt: "2026-09-24",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20warm%20family%20kitchen%20with%20steaming%20pots%20on%20an%20old%20stove%2C%20sunlight%20through%20lace%20curtains%2C%20wooden%20table%20with%20fresh%20vegetables%2C%20cozy%20nostalgic%20atmosphere%2C%20series%20still%2C%20no%20text&width=1280&height=720&seq=btb-series-family-01&orientation=landscape",
  },
  {
    id: "v-series-04",
    title: "风暴眼",
    type: "series",
    categoryId: "series-suspense",
    genres: ["悬疑", "犯罪"],
    region: "中国大陆",
    year: 2026,
    duration: "全16集",
    director: "高未",
    cast: ["邵川", "程一", "苏芷"],
    summary:
      "台风登陆的十二小时里，一栋海边酒店与外界彻底失联。六位住客各自隐瞒着同一件事，而凶手就在他们中间，等风停。",
    rating: 8.9,
    views: 17240000,
    updatedAt: "2026-10-15",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20storm%20battered%20seaside%20hotel%20at%20night%2C%20huge%20waves%20crashing%20against%20rocks%2C%20windows%20glowing%20warm%20orange%20amid%20deep%20blue%20rain%2C%20dark%20foreboding%20mood%2C%20thriller%20series%20still%2C%20no%20text&width=1280&height=720&seq=btb-series-suspense-01&orientation=landscape",
    featured: true,
  },
  {
    id: "v-series-05",
    title: "三号线公寓",
    type: "series",
    categoryId: "series-urban",
    genres: ["都市", "群像"],
    region: "中国大陆",
    year: 2023,
    duration: "全30集",
    director: "顾未",
    cast: ["林夏", "周予", "李大鹏"],
    summary:
      "地铁三号线旁的旧公寓里住着六个互不相干的年轻人。一场停电让他们第一次敲开彼此的房门，也第一次看清自己生活的样子。",
    rating: 8.0,
    views: 8290000,
    updatedAt: "2026-09-12",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20old%20apartment%20building%20beside%20an%20elevated%20metro%20line%20at%20dusk%2C%20warm%20lit%20windows%20and%20balconies%20with%20plants%2C%20city%20haze%2C%20gentle%20everyday%20mood%2C%20series%20still%2C%20no%20text&width=1280&height=720&seq=btb-series-urban-02&orientation=landscape",
  },
  {
    id: "v-series-06",
    title: "山海食记",
    type: "series",
    categoryId: "series-costume",
    genres: ["古装", "美食"],
    region: "中国大陆",
    year: 2025,
    duration: "全20集",
    director: "陆知",
    cast: ["苏芷", "段宏"],
    summary:
      "走遍山海的年轻厨子，每到一处便用当地食材做一道菜。他真正想找的，是小时候在渡口闻到过的那一缕味道。",
    rating: 8.1,
    views: 6740000,
    updatedAt: "2026-10-01",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20ancient%20open%20air%20kitchen%20beside%20a%20mountain%20river%2C%20steam%20rising%20from%20a%20clay%20pot%2C%20fresh%20herbs%20and%20wooden%20bowls%2C%20misty%20green%20hills%20behind%2C%20warm%20golden%20light%2C%20no%20text&width=1280&height=720&seq=btb-series-costume-02&orientation=landscape",
  },
  {
    id: "v-series-07",
    title: "她的第二人生",
    type: "series",
    categoryId: "series-urban",
    genres: ["都市", "女性"],
    region: "中国大陆",
    year: 2026,
    duration: "全24集",
    director: "温澜",
    cast: ["白露", "何文", "林夏"],
    summary:
      "四十岁那年，她关掉了自己创办的公司，重新回到校园读建筑。所有人都在问她为什么，只有她自己知道，这是第一次为自己做选择。",
    rating: 8.5,
    views: 11270000,
    updatedAt: "2026-10-12",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20modern%20architecture%20studio%20with%20large%20drafting%20tables%20and%20scale%20models%2C%20tall%20windows%20with%20warm%20afternoon%20light%2C%20a%20woman%20sketching%20alone%2C%20hopeful%20mood%2C%20series%20still%2C%20no%20text&width=1280&height=720&seq=btb-series-urban-03&orientation=landscape",
  },
  {
    id: "v-series-08",
    title: "雾中灯塔",
    type: "series",
    categoryId: "series-suspense",
    genres: ["悬疑", "剧情"],
    region: "中国台湾",
    year: 2024,
    duration: "全12集",
    director: "高未",
    cast: ["程一", "苏芷"],
    summary:
      "灯塔看守人每隔七年就会在同一片海域救起一个失去记忆的人。这一次被救上岸的，是二十年前失踪的自己的女儿。",
    rating: 8.6,
    views: 7380000,
    updatedAt: "2026-09-27",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20lighthouse%20on%20a%20rocky%20cliff%20surrounded%20by%20thick%20sea%20fog%20at%20dawn%2C%20beacon%20cutting%20through%20mist%2C%20cold%20grey%20water%2C%20mysterious%20quiet%20atmosphere%2C%20series%20still%2C%20no%20text&width=1280&height=720&seq=btb-series-suspense-02&orientation=landscape",
  },
  {
    id: "v-series-09",
    title: "小镇烟火",
    type: "series",
    categoryId: "series-family",
    genres: ["家庭", "生活"],
    region: "中国大陆",
    year: 2022,
    duration: "全36集",
    director: "沈青",
    cast: ["李大鹏", "张小满", "周予"],
    summary:
      "南方小镇的一条老街上，早餐铺、理发店和五金行三家邻居吵了二十年，也互相扶持了二十年。日子平淡，但每一顿早饭都热气腾腾。",
    rating: 8.2,
    views: 5810000,
    updatedAt: "2026-08-30",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20small%20southern%20chinese%20town%20street%20in%20early%20morning%2C%20breakfast%20stall%20with%20steam%20and%20hanging%20lanterns%2C%20old%20tile%20roofs%2C%20soft%20golden%20sunrise%2C%20warm%20everyday%20life%2C%20series%20still%2C%20no%20text&width=1280&height=720&seq=btb-series-family-02&orientation=landscape",
  },
  {
    id: "v-series-10",
    title: "王庭之下",
    type: "series",
    categoryId: "series-costume",
    genres: ["古装", "权谋"],
    region: "中国大陆",
    year: 2026,
    duration: "全32集",
    director: "陆知",
    cast: ["江野", "白露", "邵川"],
    summary:
      "新帝登基的第一天，御史台收到一封弹劾自己的奏折。写奏折的人就站在朝堂之上，而他知道，这场博弈从三年前的雪夜就已经开始。",
    rating: 8.3,
    views: 13950000,
    updatedAt: "2026-10-10",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20grand%20ancient%20chinese%20throne%20hall%20with%20tall%20dark%20pillars%20and%20golden%20braziers%2C%20dramatic%20shafts%20of%20light%20through%20high%20windows%2C%20lone%20figure%20in%20dark%20robes%2C%20epic%20historical%20series%20still%2C%20no%20text&width=1280&height=720&seq=btb-series-costume-03&orientation=landscape",
  },
  {
    id: "v-short-01",
    title: "办公室的猫",
    type: "short",
    categoryId: "short-funny",
    genres: ["搞笑", "职场"],
    region: "中国大陆",
    year: 2026,
    duration: "03:12",
    director: "小事工作室",
    cast: ["王小满", "橘猫阿福"],
    summary:
      "公司新来的“员工”是一只橘猫，它的工位在打印机上，职责是打断每一场冗长的会议。今天它决定竞选部门主管。",
    rating: 8.8,
    views: 3260000,
    updatedAt: "2026-10-16",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20funny%20office%20scene%20with%20a%20fluffy%20orange%20cat%20sitting%20on%20a%20printer%20in%20a%20bright%20modern%20workspace%2C%20scattered%20documents%2C%20warm%20daylight%2C%20playful%20cheerful%20mood%2C%20no%20text&width=1280&height=720&seq=btb-short-funny-01&orientation=landscape",
    featured: true,
  },
  {
    id: "v-short-02",
    title: "地铁奇遇记",
    type: "short",
    categoryId: "short-funny",
    genres: ["搞笑", "生活"],
    region: "中国大陆",
    year: 2025,
    duration: "02:48",
    director: "小事工作室",
    cast: ["李大鹏", "周予"],
    summary:
      "早高峰的地铁上，两个陌生人因为一只掉落的耳机开始了一段无声的默契配合，最后全车厢都加入了这场奇怪的接力。",
    rating: 8.2,
    views: 2140000,
    updatedAt: "2026-10-09",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20crowded%20subway%20carriage%20interior%20with%20warm%20ceiling%20lights%2C%20commuters%20standing%20close%2C%20a%20single%20white%20earbud%20falling%20in%20mid%20air%2C%20humorous%20candid%20mood%2C%20no%20text&width=1280&height=720&seq=btb-short-funny-02&orientation=landscape",
  },
  {
    id: "v-short-03",
    title: "深夜一碗面",
    type: "short",
    categoryId: "short-food",
    genres: ["美食", "治愈"],
    region: "中国大陆",
    year: 2026,
    duration: "04:05",
    director: "食光频道",
    cast: ["老陈"],
    summary:
      "凌晨一点的巷口面摊，老板只做一种面。汤底熬了六个小时，客人来了又走，有人吃完这碗面才敢回家。",
    rating: 9.0,
    views: 4820000,
    updatedAt: "2026-10-15",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20late%20night%20street%20noodle%20stall%20with%20rising%20steam%2C%20a%20bowl%20of%20rich%20broth%20noodles%20in%20foreground%2C%20warm%20hanging%20bulb%20light%2C%20dark%20alley%20background%2C%20appetizing%20cozy%20mood%2C%20no%20text&width=1280&height=720&seq=btb-short-food-01&orientation=landscape",
    featured: true,
  },
  {
    id: "v-short-04",
    title: "街角烘焙日记",
    type: "short",
    categoryId: "short-food",
    genres: ["美食", "纪录"],
    region: "中国大陆",
    year: 2025,
    duration: "03:36",
    director: "食光频道",
    cast: ["林小满"],
    summary:
      "一家只有六个座位的小面包店，每天只烤三轮。店主说，面团发酵的时间不能省，就像日子也不能跳过。",
    rating: 8.6,
    views: 1870000,
    updatedAt: "2026-10-03",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20artisan%20bakery%20counter%20with%20golden%20croissants%20and%20rustic%20sourdough%20bread%2C%20flour%20dust%20in%20warm%20morning%20light%2C%20hands%20shaping%20dough%2C%20cozy%20small%20shop%2C%20no%20text&width=1280&height=720&seq=btb-short-food-02&orientation=landscape",
  },
  {
    id: "v-short-05",
    title: "去有风的山谷",
    type: "short",
    categoryId: "short-travel",
    genres: ["旅行", "自然"],
    region: "中国大陆",
    year: 2026,
    duration: "05:20",
    director: "行者影像",
    cast: ["阿野"],
    summary:
      "从县城出发，骑行四十公里进入一条只有牧羊人知道的山谷。傍晚的风穿过整片草坡，帐篷外的星空亮得不像话。",
    rating: 8.9,
    views: 2760000,
    updatedAt: "2026-10-14",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20wide%20valley%20with%20rolling%20green%20grassland%2C%20warm%20evening%20wind%20bending%20the%20grass%2C%20distant%20blue%20mountains%2C%20a%20small%20tent%20and%20bicycle%2C%20soft%20golden%20sunset%20light%2C%20no%20text&width=1280&height=720&seq=btb-short-travel-01&orientation=landscape",
  },
  {
    id: "v-short-06",
    title: "城市漫游 24 小时",
    type: "short",
    categoryId: "short-travel",
    genres: ["旅行", "城市"],
    region: "中国大陆",
    year: 2025,
    duration: "06:10",
    director: "行者影像",
    cast: ["阿野", "苏芷"],
    summary:
      "不带攻略，只靠一张地铁票在城市里晃一整天。从清晨的菜市场到深夜的唱片店，走出一条只属于自己的路线。",
    rating: 8.4,
    views: 1620000,
    updatedAt: "2026-09-23",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20street%20corner%20in%20a%20lively%20city%20at%20dusk%2C%20tram%20passing%2C%20warm%20shop%20lights%20and%20people%20walking%2C%20slight%20motion%20blur%2C%20travel%20documentary%20mood%2C%20no%20text&width=1280&height=720&seq=btb-short-travel-02&orientation=landscape",
  },
  {
    id: "v-short-07",
    title: "阳台上的四季",
    type: "short",
    categoryId: "short-life",
    genres: ["生活", "治愈"],
    region: "中国大陆",
    year: 2026,
    duration: "02:55",
    director: "小事工作室",
    cast: ["林小满"],
    summary:
      "一个三平米的阳台，种过番茄、薄荷和三次失败的多肉。镜头记录了四季流转，也记录了一个人慢慢安顿下来的过程。",
    rating: 8.7,
    views: 1380000,
    updatedAt: "2026-10-11",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20small%20sunlit%20balcony%20garden%20with%20potted%20tomatoes%20and%20mint%2C%20watering%20can%20and%20wooden%20stool%2C%20soft%20green%20leaves%20and%20warm%20afternoon%20light%2C%20peaceful%20domestic%20mood%2C%20no%20text&width=1280&height=720&seq=btb-short-life-01&orientation=landscape",
  },
  {
    id: "v-short-08",
    title: "一个人的搬家日",
    type: "short",
    categoryId: "short-life",
    genres: ["生活", "纪录"],
    region: "中国大陆",
    year: 2024,
    duration: "04:42",
    director: "小事工作室",
    cast: ["周予"],
    summary:
      "第七次搬家，行李比上一次少了一半。空荡荡的新房间里，最先被拆开的永远是那箱书和那盏旧台灯。",
    rating: 8.1,
    views: 980000,
    updatedAt: "2026-09-15",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20empty%20new%20apartment%20room%20with%20cardboard%20boxes%20stacked%20by%20the%20window%2C%20a%20single%20old%20desk%20lamp%20glowing%2C%20late%20afternoon%20light%20on%20bare%20floor%2C%20quiet%20reflective%20mood%2C%20no%20text&width=1280&height=720&seq=btb-short-life-02&orientation=landscape",
  },
  {
    id: "v-short-09",
    title: "天台上的吉他",
    type: "short",
    categoryId: "short-music",
    genres: ["音乐", "现场"],
    region: "中国大陆",
    year: 2026,
    duration: "03:58",
    director: "声场计划",
    cast: ["阿野", "林夏"],
    summary:
      "落日之前，两个人在老楼天台上弹完了一首没写完的歌。城市在脚下轰鸣，而这一段旋律只属于那个傍晚。",
    rating: 8.8,
    views: 2050000,
    updatedAt: "2026-10-13",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20rooftop%20at%20golden%20hour%20with%20two%20people%20playing%20acoustic%20guitars%2C%20city%20skyline%20in%20soft%20haze%2C%20warm%20sun%20flare%2C%20intimate%20live%20music%20mood%2C%20no%20text&width=1280&height=720&seq=btb-short-music-01&orientation=landscape",
    featured: true,
  },
];

export const featuredVideoIds = [
  "v-movie-03",
  "v-movie-01",
  "v-movie-07",
  "v-series-04",
  "v-short-03",
];